module.exports = __webpack_public_path__ + "static/media/bazterrica.011e76e6.svg";